export default function GeneralCatalystSvg({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      width="1453"
      height="182"
      viewBox="0 0 1453 182"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M812.636 181.27C762.673 181.27 722 140.849 722 90.634C722 40.42 762.673 0.25 812.636 0.25C844.522 0.25 872.39 16.82 888.709 41.676L871.386 52.974C862.096 38.161 843.014 20.838 812.636 20.838C774.222 20.838 742.839 52.221 742.839 90.634C742.839 129.299 773.972 160.683 812.636 160.683C841.508 160.683 861.092 143.61 871.134 128.797L888.458 140.096C872.389 164.952 844.269 181.27 812.635 181.27H812.636Z"
        fill="black"
      />
      <path
        d="M937.41 0C959.755 0 973.563 16.821 973.563 36.404V178.509H952.725V100.928H921.843V178.509H901.004V36.404C901.004 15.566 916.068 0 937.408 0H937.41ZM942.431 20.839H932.137C926.363 20.839 921.844 25.358 921.844 31.132V80.342H952.726V31.132C952.726 25.358 948.205 20.839 942.431 20.839Z"
        fill="black"
      />
      <path
        d="M1056.16 23.3487H1030.3V178.509H1009.47V23.3487H983.605V2.76074H1056.17L1056.16 23.3487Z"
        fill="black"
      />
      <path
        d="M1102.61 0C1124.96 0 1138.77 16.821 1138.77 36.404V178.509H1117.93V100.928H1087.05V178.509H1066.21V36.404C1066.21 15.566 1081.27 0 1102.61 0ZM1107.63 20.839H1097.34C1091.57 20.839 1087.05 25.358 1087.05 31.132V80.342H1117.93V31.132C1117.93 25.358 1113.41 20.839 1107.63 20.839Z"
        fill="black"
      />
      <path
        d="M1215.09 178.51H1193.5C1169.89 178.51 1157.84 164.199 1157.84 143.109V2.76172H1178.68V152.649C1178.68 155.411 1181.19 157.921 1183.96 157.921H1215.09V178.51Z"
        fill="black"
      />
      <path
        d="M1257.26 100.929V178.259H1236.42V100.929C1220.1 100.929 1210.56 89.3797 1210.56 75.0687V2.76172H1231.4V75.0687C1231.4 77.8307 1233.66 80.3417 1236.42 80.3417H1257.26C1260.02 80.3417 1262.28 77.8297 1262.28 75.0687V2.76172H1283.12V75.0687C1283.12 89.1287 1274.08 100.929 1257.26 100.929Z"
        fill="black"
      />
      <path
        d="M1371 115.49V145.87C1371 166.458 1356.69 181.27 1335.85 181.27H1333.84C1313 181.27 1298.69 166.458 1298.69 145.87V124.278H1319.28V155.41C1319.28 158.173 1321.54 160.683 1324.55 160.683H1345.14C1348.15 160.683 1350.41 158.172 1350.41 155.41V105.95C1350.41 103.189 1348.15 100.929 1345.14 100.929H1333.84C1313.25 100.929 1298.69 85.865 1298.69 65.529V35.4C1298.69 15.064 1313.25 0 1333.84 0H1335.85C1356.44 0 1371 15.314 1371 35.4V57.243H1350.41V25.86C1350.41 23.098 1348.15 20.839 1345.14 20.839H1324.55C1321.54 20.839 1319.28 23.098 1319.28 25.86V75.069C1319.28 77.831 1321.54 80.09 1324.55 80.09H1335.6C1356.94 80.09 1371 94.652 1371 115.49Z"
        fill="black"
      />
      <path
        d="M1452.84 23.3487H1426.98V178.509H1406.14V23.3487H1380.28V2.76074H1452.84V23.3487Z"
        fill="black"
      />
      <path
        d="M90.3852 181.27C40.4222 181.27 -0.250835 140.598 0.00116471 90.6342C0.00116471 40.6725 40.9252 -0.000913024 90.8872 0.249687C115.743 0.249687 138.088 10.5432 154.408 26.8625L139.846 41.425C126.539 28.1181 108.964 20.8368 90.3852 20.8368C52.7252 20.8368 20.3372 51.7176 20.8392 91.3872C21.3412 129.55 51.4702 160.18 90.1342 160.682C121.016 160.682 150.14 139.842 158.174 107.455C159.178 102.685 157.169 101.179 153.906 101.179H90.3852V80.3407H164.953C174.242 80.3407 180.016 86.8672 180.016 96.4092C180.016 139.843 141.101 181.269 90.3842 181.269L90.3852 181.27Z"
        fill="black"
      />
      <path
        d="M249.055 23.3494H212.901V80.342H248.052V100.93H212.901V157.922H249.055V178.51H192.062V2.76221H249.055V23.3494Z"
        fill="black"
      />
      <path
        d="M266.879 2.76077H287.215L317.344 100.928C317.846 102.434 318.599 102.936 319.603 102.685C320.607 102.434 320.607 100.928 320.607 99.9231L319.854 2.75977H339.688V178.507H319.1L289.224 80.0881C288.972 78.8334 288.47 77.5768 287.215 77.8293C285.709 78.0798 285.96 80.0881 285.96 81.3451L286.713 178.507H266.879V2.75977V2.76077Z"
        fill="black"
      />
      <path
        d="M416.762 23.3494H380.609V80.342H415.758V100.93H380.609V157.922H416.762V178.51H359.77V2.76221H416.762V23.3494Z"
        fill="black"
      />
      <path
        d="M481.284 100.93H455.424V178.51H434.586V2.76221H476.011C495.595 2.76221 507.144 15.065 507.144 33.644V71.5555C507.144 81.8495 503.628 86.6195 496.85 90.6355C504.131 94.6525 507.144 100.177 507.144 109.467V178.51H486.305V106.202C486.305 103.189 484.047 100.93 481.284 100.93ZM486.306 75.0689V28.6215C486.306 25.6082 484.047 23.3494 481.284 23.3494H455.424V80.342H481.284C484.046 80.342 486.306 77.8307 486.306 75.0689Z"
        fill="black"
      />
      <path
        d="M562.626 0C584.966 0 598.776 16.8213 598.776 36.4044V178.508H577.936V100.928H547.057V178.508H526.219V36.4044C526.219 15.5657 541.282 0 562.626 0ZM567.646 20.8387H557.352C551.578 20.8387 547.058 25.3582 547.058 31.1323V80.3415H577.936V31.1323C577.936 25.3582 573.416 20.8387 567.646 20.8387Z"
        fill="black"
      />
      <path
        d="M675.095 178.51H653.505C629.905 178.51 617.855 164.199 617.855 143.11V2.76221H638.696V152.65C638.696 155.412 641.205 157.922 643.965 157.922H675.095V178.51Z"
        fill="black"
      />
    </svg>
  );
}
